/**
 * @module handlers/labelContent
 * @description 维/指数量变化时，按图种清洗 labelContent；开关开启时空数组补默认
 */

import { ensureLabelContentForChart } from '@dbl/core/chartEditor';
import type { IQBLinkageHandler } from '../types';
import { hasConfigInLayers, patchBoth } from './shared';

function resolveShowDataLabel(
  layer: Record<string, unknown>,
  fallbackLayer: Record<string, unknown>,
): boolean {
  if (typeof layer.showDataLabel === 'boolean') {
    return layer.showDataLabel;
  }
  return fallbackLayer.showDataLabel === true;
}

export const labelContentHandler: IQBLinkageHandler = {
  id: 'labelContent',
  phase: 'sanitize',
  keys: ['labelContent'],
  subscribe: [
    'dimensionAdded',
    'dimensionRemoved',
    'metricAdded',
    'metricRemoved',
    'dimCountChanged',
    'metricCountChanged',
  ],
  apply(_changeSet, ctx) {
    if (!hasConfigInLayers(ctx.base, ctx.draft, 'labelContent')
      && ctx.base.showDataLabel !== true
      && ctx.draft.showDataLabel !== true) {
      return;
    }

    const chartType = ctx.chartType ?? '';
    const dimensionCount = ctx.qb.columnDimensions?.length ?? 0;
    const metricCount = ctx.qb.columnMetrics?.length ?? 0;

    const runLayer = (
      layer: Record<string, unknown>,
      fallbackLayer: Record<string, unknown>,
    ) => {
      // 与切图 reconcile 一致：本层未拥有 labelContent 时不物化默认值
      if (!('labelContent' in layer)) {
        return { changed: false as const, next: [] as string[] };
      }
      return ensureLabelContentForChart({
        labelContent: layer.labelContent,
        showDataLabel: resolveShowDataLabel(layer, fallbackLayer),
        chartType,
        dimensionCount,
        metricCount,
      });
    };

    const baseResult = runLayer(ctx.base, ctx.draft);
    const draftResult = runLayer(ctx.draft, ctx.base);

    if (!baseResult.changed && !draftResult.changed) {
      return;
    }

    return patchBoth(
      baseResult.changed ? { labelContent: baseResult.next } : undefined,
      draftResult.changed ? { labelContent: draftResult.next } : undefined,
    );
  },
};
